import { Pipe, PipeTransform } from '@angular/core';
import { getSearchResultUrl } from './search.functions';
import { StateService } from '@uirouter/angular';

@Pipe({
  name: 'searchResultUrl'
})
export class SearchResultUrlPipe implements PipeTransform {

    constructor(private stateService: StateService) {}

    transform(result: any): any {
        return getSearchResultUrl(result, this.stateService);
    }
};